'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var Resx = (0, _localize2.default)('App', 'Common');
  var $box = (0, _jquery2.default)('#offlineBox', this);
  var cookieName = 'offModeInfoBox';
  var $closeBoxButton = (0, _jquery2.default)('#offlineBoxClose');
  var boxCloseClass = 'warning__wrap--hidden';
  var cookieParam = _cookie2.default.getCookie(cookieName);
  var d = new Date();
  d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000);

  var expires = ";expires=" + d.toUTCString();

  if (cookieParam !== '1') {
    $box.removeClass(boxCloseClass);
    $closeBoxButton.html(Resx.Common.Close);
  } else {
    $closeBoxButton.html(Resx.App.Show);
  }

  var iniBox = function iniBox() {
    if ($box.hasClass(boxCloseClass)) {
      $box.removeClass(boxCloseClass);
      $closeBoxButton.html(Resx.Common.Close);
    } else {
      $box.addClass(boxCloseClass);
      $closeBoxButton.html(Resx.App.Show);
      if (cookieParam === undefined) document.cookie = cookieName + '=1;' + expires + ';path=/';
    }
  };

  (0, _jquery2.default)(this).on('click', '#offlineBoxClose', iniBox);
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/offlineBox.js
// module id = 1181
// module chunks = 0